import React from 'react';
import { Box } from '@qga/roo-ui/components';

import type { CheapestOffer } from '@shared/v2/utils/getPackageOptions';

import Heading from '@/components/Heading';
import PackageHeroSummary from '@/components/PackageHeroSummary';
import PricePerTraveller from '@/components/PricePerTraveller';
import Text from '@/components/Text';

const LeadInOffer = ({ offer }: { offer: CheapestOffer }) => {
  const nights = offer.cheapestRoute.nights;
  const travellers = offer.cheapestRoute.travellers;
  const displayTravellerTypes = offer.cheapestRoute.displayTravellerTypes;

  return (
    <Box>
      {offer && offer.cheapestRoute.price && (
        <>
          <PackageHeroSummary showNights nights={nights} exact />
          {/* @ts-ignore Bad JSX types */}
          <PricePerTraveller
            {...offer.cheapestRoute.price}
            displayTravellerTypes={displayTravellerTypes}
            travellers={travellers}
          />
        </>
      )}
      {!offer.cheapestRoute.price && (
        <Box maxWidth={[null, null, '280px']}>
          <Heading.h5 color={'brand.primary'} textAlign="right">
            Check availability for package pricing
          </Heading.h5>
        </Box>
      )}
      {offer.cheapestRoute.origin?.name && (
        <Box textAlign="right" color="text.body" mt={2}>
          <Text
            fontSize={['14px', null, '16px']}
            lineHeight={['20px', null, '24px']}
            letterSpacing="0.1px"
          >{`Departing ${offer.cheapestRoute.origin?.name}`}</Text>
        </Box>
      )}
    </Box>
  );
};

export default LeadInOffer;
